import { Module, ActionContext } from 'vuex'
import { RootState, TasksState } from '../store/state_models'
import { Task } from '../models'
import RecurringTaskService from '../services/RecurringTasksService'

export const tasks: Module<TasksState, RootState> = {
  namespaced: true,
  state: { tasks: {}, recurringTasks: { } },
  getters: {
    getById: (
        state: TasksState
      ) => {
        return (taskId: string) => state.tasks[taskId]
      },
    getRecurringTaskById: (
        state: TasksState
      ) => {
        return (locationId: string, taskId: string) => state.recurringTasks[locationId]?.[taskId]
      },
    getRecurringTasksInLocation: (
        state: TasksState
      ) => {
        return (locationId: string) => state.recurringTasks[locationId]
      }
  },
  mutations: {
    addTask: (state: TasksState, task: any) => {
        state.tasks[task.id] = Object.freeze(task)
    },
    setRecurringTask: (state: TasksState, { task, locationId }) => {
      if (!state.recurringTasks[locationId]) {
        state.recurringTasks[locationId] = {}
      }
      state.recurringTasks[locationId][task.id] = Object.freeze(task)
    },
    removeRecurringTasks: (state: TasksState, { taskIds, locationId }) => {
      taskIds.forEach((taskId: string) => {
        delete state.recurringTasks[locationId][taskId]
      })
    },
    clearAll: (state: TasksState) => {
      state.tasks = {}
    },
    setRecurringTasksInLocation: (state: TasksState, { ids, recurringTasks, locationId }) => {
      if (!state.recurringTasks[locationId]) {
        state.recurringTasks[locationId] = {}
      }

      const removedIds = ids.filter((id: string) => !recurringTasks.some((task: any) => task.id === id))
      removedIds.forEach((id: string) => {
        delete state.recurringTasks[locationId][id]
      })
      recurringTasks.forEach((task: any) => {
        state.recurringTasks[locationId][task.id] = Object.freeze(task)
      })
    }
  },
  actions: {
    getById: {
        handler: (
        context: ActionContext<TasksState, RootState>,
        taskId: string
        ): Promise<Task> => {
        return new Promise(async (resolve, reject) => {
            try {
            let task = context.getters['getById'](taskId)
            if (task) {
                return resolve(task)
            }

            const obj = await Task.getById(taskId)
            task = { ...obj.data, id: obj.id }
            context.commit('addTask', task)
            resolve(task)
            } catch {
            reject()
            }
        })
        }
    },
    logout: {
        root: true,
        handler: async (context: ActionContext<TasksState, RootState>) => {
            context.commit('clearAll')
        }
    },
    clearAll: {
        handler: async (context: ActionContext<TasksState, RootState>) => {
            context.commit('clearAll')
        }
    },
    getRecurringTasksInLocation: {
        handler: async (
        context: ActionContext<TasksState, RootState>,
        locationId: string
        ) => {
        return new Promise(async (resolve, reject) => {
          try {
            const response = await RecurringTaskService.getRecurringTasksInLocation(locationId)
            context.commit('setRecurringTasksInLocation', { recurringTasks: response.data.recurringTasks, locationId })
            resolve(response.data.recurringTasks)
          } catch {
            reject()
          }
        })
      }
    },
    getRecurringTasksByIds: {
        handler: async (
        context: ActionContext<TasksState, RootState>,
        { locationId, taskIds }: { locationId: string, taskIds: string[] }
        ) => {
        return new Promise(async (resolve, reject) => {
          try {
            const response = await RecurringTaskService.getRecurringTasksByIds(locationId, { ids: taskIds })
            context.commit('setRecurringTasksInLocation', { ids: taskIds, recurringTasks: response.data.recurringTasks, locationId })
            resolve(response.data.recurringTasks)
          } catch {
            reject()
          }
        })
      }
    },
  }
}
